export const cognitoApiEndPoints = {
    // eslint-disable-next-line max-len
    loginURL: `${import.meta.env.VITE_COGNITO_URL}/login?response_type=code&client_id=${import.meta.env.VITE_COGNITO_CLIENT_ID}&redirect_uri=${import.meta.env.VITE_SSO_CALLBACK_URL}`,
    tokenURL: `${import.meta.env.VITE_COGNITO_URL}/oauth2/token`,
    userInfo: `${import.meta.env.VITE_COGNITO_URL}/oauth2/userInfo`,
    ssoLoginURL: `${import.meta.env.VITE_SSO_URL}/login?callbackUrl=${import.meta.env.VITE_SSO_CALLBACK_URL}`,
  };
export const appApiEndPoints = {
};
  